"use client";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var analytics = null;
var segmentPromise = null;
export function getAnalytics() {
    return __awaiter(this, void 0, void 0, function () {
        var analytics;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    //if (analytics) return analytics;
                    if (!segmentPromise) {
                        segmentPromise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var AnalyticsBrowser_1, analytics_1, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, import("@segment/analytics-next")];
                                    case 1:
                                        AnalyticsBrowser_1 = (_a.sent()).AnalyticsBrowser;
                                        analytics_1 = AnalyticsBrowser_1.load({
                                            writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
                                        });
                                        resolve(analytics_1);
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        reject(error_1);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    return [4 /*yield*/, segmentPromise];
                case 1:
                    analytics = _a.sent();
                    return [2 /*return*/, analytics];
            }
        });
    });
}
export function getAnalyticsReplay() {
    return __awaiter(this, void 0, void 0, function () {
        var LogRocket;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import("logrocket")];
                case 1:
                    LogRocket = (_a.sent()).default;
                    return [2 /*return*/, LogRocket];
            }
        });
    });
}
export function setupAnalyticsReplay() {
    return __awaiter(this, void 0, void 0, function () {
        "use client";
        var _a, LogRocket, setupLogRocketReact;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        getAnalyticsReplay(),
                        import("logrocket-react"),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), LogRocket = _a[0], setupLogRocketReact = _a[1].default;
                    LogRocket.init("bwegxr/hotels-white-label");
                    setupLogRocketReact(LogRocket);
                    return [2 /*return*/];
            }
        });
    });
}
